export default __webpack_public_path__ + "static/media/polaroid7.b1893b91.jpg";